import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { IssueItemAuditStatus } from '../../../classes';
import { IIssueAuditWrapperProvider, ISSUE_AUDIT_WRAPPER_PROVIDER } from '../../../interfaces';

@Component({
  selector: 'app-issue-item-audit',
  templateUrl: './issue-item-audit.component.html',
  styleUrls: ['./issue-item-audit.component.css']
})
export class IssueItemAuditComponent implements OnDestroy, OnInit {

  private _audit = new ReplaySubject<IssueItemAuditStatus[]>();
  @Input() set issueItemAuditStatus(audit: IssueItemAuditStatus[]){
    this._audit.next(audit);
  }

  createdItems$ = this._audit.pipe(map(x => x.filter(y => y.anchestorId === null)));
  updatedItems$ = this._audit.pipe(map(x => x.filter(y => y.anchestorId !== null)));

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_AUDIT_WRAPPER_PROVIDER) private _issueAuditWrapperProvider: IIssueAuditWrapperProvider
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._issueAuditWrapperProvider.issueAuditWrapper$.subscribe((wrapper) => this.issueItemAuditStatus = wrapper.issueItemStatus)
    ]);
  }

}
